import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  position: fixed;
  top: 72px;
  left: calc(((100vw - 768px) / 2) + 768px);
  padding-left: 14px;
  z-index: 5;
  max-width: calc((100vw - 768px) / 2);
  background: ${props => props.theme.white};
  border-radius: 12px;
  box-shadow: 4px 2px 5px ${props => props.theme.shadow};
  /* border: 1px solid ${props => props.theme.border}; */
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;

  label {
    margin-left: 30px;
    margin-bottom: 8px;
    margin-top: 18px;
  }

  .separator {
    height: 1px;
    width: 100%;
    background: rgb(221, 226, 229);
    margin: 4px 0px;
  }

  .setup-actions {
    display: flex;
    flex-direction: column;

    .setup-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px;
      padding-left: 28px;
      padding-right: 24px;
      font-weight: 500;
      color: ${props => props.theme.normalText};
      cursor: pointer;
      transition:
        background 0.15s ease,
        color 0.15s ease;
      background: transparent;

      svg {
        color: ${props => props.theme.accent};
        width: 20px;
        font-size: 18px;
        margin-right: 8px;
      }

      &:hover {
        background: ${props => props.theme.activeBackground};
        color: ${props => props.theme.accent};
      }

      &[data-completed='true'] {
        svg {
          color: ${props => props.theme.green};
        }
      }
    }
  }

  @media (max-width: 1024px) {
    position: static;
    padding: 0;
    margin-top: 24px;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 4px 12px ${props => props.theme.middleShadow};
    margin-bottom: 16px;

    label {
      margin-left: 16px !important;
    }

    .setup-item {
      padding-left: 18px !important;
    }
  }
`
